import { render, staticRenderFns } from "./AccountTypesView.vue?vue&type=template&id=793131d2&scoped=true&"
import script from "./AccountTypesView.vue?vue&type=script&lang=js&"
export * from "./AccountTypesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793131d2",
  null
  
)

export default component.exports